export default __webpack_public_path__ + "static/media/HP4.71a142ea.jpg";